import React, { useEffect } from "react"
import { RellaxWrapper as Rellax } from "react-rellax-wrapper"
import fireConfetti from "canvas-confetti"

import * as s from "./EuroHeader.module.scss"

import pint from "@assets/images/euro-header/pint.png"
import logos from "@assets/images/euro-header/logos.png"
import fans from "@assets/images/euro-header/fans.png"
import fansMobile from "@assets/images/euro-header/fans-mobile.png"
import confetti from "@assets/images/euro-header/confetti.png"

export const EuroHeader = ({ data }) => {
  const { titleText, introPanelTitle, introText } = data

  const confettiTrigger = () => {
    fireConfetti({
      particleCount: 150,
      angle: 90,
      spread: 150,
      drift: 1,
      origin: { x: 0.2, y: 0.45 },
      colors: ["#ffffff", "#c8102e", "#141d30"],
      scalar: 1.3,
      disableForReducedMotion: true,
      ticks: 150,
    })
    fireConfetti({
      particleCount: 150,
      angle: 90,
      spread: 150,
      drift: -1,
      origin: { x: 0.8, y: 0.45 },
      colors: ["#ffffff", "#c8102e", "#141d30"],
      scalar: 1.3,
      disableForReducedMotion: true,
      ticks: 150,
    })
  }

  useEffect(confettiTrigger, [])

  return (
    <div className={s.wrapper}>
      <div className={s.splash}>
        <div className={s.overflowHidden}>
          <img src={logos} alt="" className={s.logos} />
          <h2 dangerouslySetInnerHTML={{ __html: titleText }} />

          <Rellax speed={-7} className={s.confetti}>
            <img src={confetti} alt="" />
          </Rellax>

          <Rellax speed={-3} className={s.fans}>
            <picture>
              <source media="(max-width: 470px)" srcSet={fansMobile} />
              <img src={fans} alt="" />
            </picture>
          </Rellax>
        </div>

        <Rellax xs={0} mobile={3} tablet={3} desktop={3} className={s.pint}>
          <img src={pint} alt="" onClick={confettiTrigger} />
        </Rellax>
      </div>
      <div className={s.intro}>
        <h1>{introPanelTitle}</h1>
        <div
          className={s.text}
          dangerouslySetInnerHTML={{ __html: introText }}
        />

        <div className={s.btnWrapper}>
          <button
            className={s.btn}
            onClick={() =>
              document
                .getElementById("shop-billboard")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Celebrate at home
          </button>
          <button
            className={s.btn}
            onClick={() =>
              document
                .getElementById("bar-finder")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Celebrate at the pub
          </button>
        </div>
      </div>
    </div>
  )
}
